import { getCookie, setLocaleCookie } from "../plugins/cookies"

export default {
    state: {
        settings: [],
        whitelabelId: '',
        subid: '',
        title: '',
        contact: '',
        contact_person: '',
        javascript: '',
        language: '',
        country: '',
        global_config: [],
        starcar: ''
    },

    getLanguageUnit() {
        return this.language
    },

    getMileageUnit() {
        return this.global_config.mileage_unit
    },

    getCurrencySign() {
        return this.global_config.currencies[this.global_config.currency].symbol
    },

    getCurrencyIso() {
        return this.global_config.currency.toLowerCase()
    },

    getMileageTextUnit() {
        return this.global_config.mileage_text
    },

    getPowerUnit() {
        return this.global_config.power_unit
    },

    handleResponse(response, userState, vue = null) {
        let locale = null
        if(getCookie('locale') !== null) {
            locale = getCookie('locale')
        } else {
            let wlLocales = response.data.whitelabel_settings.languages

            if (Array.isArray(wlLocales)) {
                if(wlLocales.length < 1) {
                    console.error("No whitelabel locales found")
                } else {
                    locale = wlLocales[0]
                }
            } else {
                locale = wlLocales
            }
        }


        this.setLanguage(locale, response.data.whitelabel_settings.wlCountry);

        let shortLanguage = this.getLanguage();

        switch (shortLanguage) {
            case 'de-DE-formal':
                shortLanguage = 'de-formal';
                break;
            case 'de-DE-informal':
                shortLanguage = 'de-informal';
                break;
            default:
                shortLanguage = shortLanguage.substr(0, 2);
        }

        this.global_config = response.data.whitelabel_settings.global_config[this.country][shortLanguage] ?? [];

        this.set18(locale, this.global_config, vue);

        this.setupWhitelabelDesign(response.data.whitelabel_settings);

        if(response.data.whitelabel_style) {
            this.setupWhitelabelStyle(response.data.whitelabel_style);
        }

        if(response.data.whitelabel_javascript) {
            this.addJavascript(response.data.whitelabel_javascript);
        }

        this.state.whitelabelId = response.data.whitelabel_id;
        this.state.settings = response.data.whitelabel_settings;
        this.state.subid = response.data.whitelabel_subid;
        this.state.title = response.data.whitelabel_title;
        this.state.contact = response.data.whitelabel_contact;
        this.state.javascript = response.data.whitelabel_javascript;
        this.state.contact_person = response.data.whitelabel_contact_person;
        this.state.settings.uses_ref_codes = response.data.whitelabel_settings.ref_code_required || response.data.whitelabel_settings.optional_ref_code_checkout;
        this.state.settings.requires_ref_code = response.data.whitelabel_settings.ref_code_required;
        this.state.settings.optional_ref_code = response.data.whitelabel_settings.optional_ref_code_checkout;
        this.state.settings.deposit = response.data.whitelabel_deposit;
        this.state.starcar = response.data.starcar;

        if(response.data.user && response.data.user.data) {
            userState.loggedIn();
            userState.setData({...response.data.user.data, driver_status: response.data.user.driver_status, core_user: response.data.user.core_user});

            if(response.data.user.mail_verified){
                userState.verifiedMail();
            }
        }
    },

    setting($key) {
        return this.state.settings[$key]
    },

    isLeads() {
        return this.state.settings.leads_feature_active && this.state.settings.leads_active && this.state.settings.leads_url;
    },

    sub_id() {
        return this.state.subid;
    },

    contact_person() {
        return this.state.contact_person;
    },

    getSettings() {
        return this.state.settings;
    },

    isB2b() {
        return this.state.settings.is_b2b;
    },

    usesRefCodesInCheckout() {
        return this.state.settings.uses_ref_codes && this.state.settings.optional_ref_code;
    },

    isUs() {
        return this.language === 'en-US';
    },

    isCa() {
        return this.language === 'en-CA' || this.language === 'fr-CA';
    },

    getFooterLayout() {
        switch (this.country) {
            case 'ca':
                return 'FooterBarCanada'
            default:
                return 'FooterBar'
        }
    },

    getDefaultImage() {
        switch (this.country) {
            case 'ca':
            case 'us':
                return 'https://a.storyblok.com/f/137136/1941x867/9692172cf4/default_placeholder_english.png'
            default:
                return 'https://a.storyblok.com/f/137136/647x289/488f5e5059/platzhalter.png'
        }
    },

    buildFaviconUrl(size){
        const url = this.state.settings.favicon_image
        if (url !== null && typeof url !== 'undefined') {
            const splittedUrl = url.split('/')
            const fileName = splittedUrl[splittedUrl.length - 1]
            const filenameWithoutEnding = fileName.split('.')[0]
            const baseUrl = url.replace(fileName,'')

            return `${baseUrl}c/${filenameWithoutEnding}-${size}.jpg`
        } else {
            return ''
        }
    },

    setupWhitelabelDesign(settings){
        /*
        * remove settings and switch to style
        */
        document.documentElement.style.setProperty("--primary", settings.primary_color ?? '#1890ff');
        document.documentElement.style.setProperty("--primary-text", settings.primary_color_text ?? '#262626');
        document.documentElement.style.setProperty("--main-menu-background", settings.navigation_color ?? '#fafafa');
        document.documentElement.style.setProperty("--main-menu-text", settings.navigation_color_text ?? '#262626');
    },

    setupWhitelabelStyle(style){
        var s = document.createElement("style");
        s.innerHTML = style.own_css
        document.getElementsByTagName("head")[0].appendChild(s)
    },

    addJavascript(javascript) {
        var script = document.createElement("script");
        script.innerHTML = javascript.own_js;
        document.head.appendChild(script);
    },

    setLanguage(locale, wlCountry) {
        // find country on language (if more then one result choose by response.data.whitelabel_settings.wlCountry )

        let countryCode = locale.split('-')[1].toLowerCase();
        this.country = countryCode;
        this.language = locale;
    },

    getLanguage() {
        return this.language
    },

    getFormatetPrice(price) {
        return new Intl.NumberFormat(
            this.getLanguage(),
            {
                style: 'currency',
                currency: this.getCurrencyIso()
            }
        ).format(price)

    },

    set18(locale, global_config, vue) {

        vue.$root.$i18n.locale = locale;

        let numberFormats =  {
            currency: {
                style: 'currency',
                currency: global_config.currency
            },
            number: {
                maximumFractionDigits: 2,
            }
        };

        let dateTimeFormats = {
            short: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
                hour: 'numeric',
                minute: 'numeric'
            }
        };

        vue.$root.$i18n.locale = locale
        vue.$root.$i18n.setNumberFormat(locale, numberFormats)
        vue.$root.$i18n.setDateTimeFormat(locale, dateTimeFormats)
    }

}
